import { styled } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import { IconButton, type IconButtonProps } from "@mui/material";

export const StyledDrawerButton = styled(({ ...props }: IconButtonProps) => (
  <IconButton {...props}>
    <MenuIcon sx={{ fontSize: 30 }} />
  </IconButton>
))(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "none",
  },
}));
